import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormControl  } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { map, Observable, startWith, debounceTime } from 'rxjs';
import { trigger, transition, style, animate } from '@angular/animations';
import { CatalogosApiService } from 'src/app/core/services/catalogos-api.service';

@Component({
  selector: 'filter-search-job',
  standalone: false,
  templateUrl: './filter-search-job.component.html',
  styleUrl: './filter-search-job.component.scss',
  animations: [
    trigger('slideDownUp', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('200ms ease-out', style({ height: '*', opacity: 1 })),
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ height: 0, opacity: 0 })),
      ]),
    ])
  ]
})
export class FilterSearchJobComponent implements OnInit {

  @Input() action!: (data: any[]) => void;
  @Input() isHome: boolean = false;
  @Input() urlFilters: any = {}; // Nueva entrada para recibir filtros de URL
  @Output() filtrosChange = new EventEmitter<any>();

  locationSearchControl = new FormControl();
  locationFilterId = "";
  searchControl = new FormControl();
  jobFilterId = '';
  hasFilters = false;
  postDateControl: FormControl = new FormControl(null);
  salaryControl: FormControl = new FormControl('-1');
  salaryFilterId = "";
  filteredLocationItems!: Observable<any[]>;
  filteredItems!: Observable<any[]>;
  locationItems: any[] = [];
  items: any[] = [];
  salaryItems: any[] = [];

  postDateOptions = [{ value: "0", label: "post-date" },
  { value: "1", label: "3daysago" },
  { value: "2", label: "7daysago" },
  { value: "3", label: "15daysago" },
  { value: "4", label: "30aysago" },
  { value: "5", label: "more30daysago" }]

  


  constructor(private catalogosApiService: CatalogosApiService, private router: Router, private route: ActivatedRoute) {
    this.filteredItems = this.searchControl.valueChanges.pipe(
      startWith(''),
      map(valor => (typeof valor === 'string' ? valor : valor?.puesto)),
      map(puesto => puesto ? this.filterItems(puesto) : this.items.slice())
    );
    this.filteredLocationItems = this.locationSearchControl.valueChanges.pipe(
      startWith(''),
      map(value => (typeof value === 'string' ? value : value?.entidad)),
      map(entidad => entidad ? this.filterLocationItems(entidad) : this.locationItems.slice())
    );
  }
  ngOnInit(): void {
    // Configurar listeners según el modo (isHome)
    this.setupFilterListeners();

    // Aplicar filtros de URL si están disponibles
    this.applyUrlFilters();

    this.catalogosApiService.getEntidadesFederativas().subscribe(
      (data: any) => {
        let _payload: any = data.payload;
        this.locationItems = _payload.data;
        
        // Priorizar filtros de URL sobre queryParams
        const locationFilter = this.urlFilters?.idUbicacion || this.route.snapshot.queryParams['idUbicacion'] || '';
        if (locationFilter) {
          const locationItem = this.locationItems.find(item => 
            (item.entidad).trim().toUpperCase() === locationFilter.trim().toUpperCase()
          );
          if (locationItem) {
            this.locationSearchControl.setValue(locationItem);
          } else {
            // Si no se encuentra en el catálogo, usar el valor como texto
            this.locationSearchControl.setValue(locationFilter);
          }
        }
      }, (error: {}) => {
        console.error(error);
      }
    );

    this.catalogosApiService.getPuestos().subscribe(
      (data: any) => {
        let _payload: any = data.payload;
        this.items = _payload.data;
        
        // Priorizar filtros de URL sobre queryParams
        const jobFilter = this.urlFilters?.idPuesto || this.route.snapshot.queryParams['idPuesto'] || '';
        if (jobFilter) {
          const jobItem = this.items.find(item => 
            (item.puesto).trim().toUpperCase() === jobFilter.trim().toUpperCase()
          );
          if (jobItem) {
            this.searchControl.setValue(jobItem);
          } else {
            // Si no se encuentra en el catálogo, usar el valor como texto
            this.searchControl.setValue(jobFilter);
          }
        }
      }, (error: {}) => {
        console.error(error);
      }
    );

    this.findSueldos();
    
    // Solo usar queryParams si no hay urlFilters
    if (!this.urlFilters || Object.keys(this.urlFilters).length === 0) {
      this.route.queryParams.subscribe(params => {
        this.postDateControl.setValue(params['pdFilter'] || "0");
        this.salaryFilterId = params['salario'] || "0";
        this.jobFilterId = params['idPuesto'] || "";
        this.locationFilterId = params['idUbicacion'] || "";
        this.validateHasFilter();
        this.searchControl.setValue(this.jobFilterId);
        this.locationSearchControl.setValue(this.locationFilterId);
        // Emitir filtros iniciales
        setTimeout(() => this.emitirFiltros(), 100);
      });
    } else {
      // Emitir filtros iniciales cuando se usan urlFilters
      setTimeout(() => this.emitirFiltros(), 100);
    }
  }

  // Método para aplicar filtros de URL
  private applyUrlFilters(): void {
    if (!this.urlFilters || Object.keys(this.urlFilters).length === 0) return;

    console.log('Aplicando filtros de URL:', this.urlFilters);

    // Aplicar filtro de fecha de publicación
    if (this.urlFilters.antiguedad) {
      this.postDateControl.setValue(this.urlFilters.antiguedad);
      console.log('Fecha de publicación establecida:', this.urlFilters.antiguedad);
    }

    // Aplicar filtro de sueldo si está disponible
    if (this.urlFilters.sueldo) {
      // Este se manejará cuando se carguen los datos de salarios
      this.salaryFilterId = this.urlFilters.sueldo;
    }

    // Los filtros de puesto y ubicación se manejan en los observables de los catálogos
    this.validateHasFilter();
  }

  findSueldos() {
    this.catalogosApiService.getSueldos().subscribe(
      (data: any) => {
        let _payload: any = data.payload;
        this.salaryItems = _payload.data;
        this.salaryItems.unshift({ idSueldo: "-1", sueldo: "salary" })
        
        // Priorizar filtros de URL sobre salaryFilterId de queryParams
        
         
        const salaryFilter = this.urlFilters?.sueldo || this.salaryFilterId;
        console.log('------------------> Valor de salaryFilterId:', salaryFilter);
        if (salaryFilter && salaryFilter !== "" && salaryFilter !== "0" && salaryFilter !== "-1") {
          // Buscar por idSueldo o por texto de sueldo
          const salaryItem = this.salaryItems.find(item => 
            item.idSueldo == salaryFilter || 
            (item.sueldo && item.sueldo.toLowerCase().includes(salaryFilter.toLowerCase()))
          );
          
          if (salaryItem) {
            this.hasFilters = true;
            this.salaryControl.setValue(salaryItem.idSueldo);
            console.log('Filtro de sueldo aplicado:', salaryItem);
          } else {
            console.log('No se encontró el filtro de sueldo:', salaryFilter);
          }
        }
      }, (error: {}) => {
        console.error(error);
      }
    );
  }

  filterItems(valor: string): { idPuesto: number; puesto: string; idArea: number }[] {
    const filterValue = valor?.toLowerCase();
    return this.items.filter(item => item.puesto.toLowerCase().includes(filterValue));
  }
  showJobName(objeto: any): string {
    return objeto && objeto.puesto ? objeto.puesto : '';
  }
  selectItem(item: any) {
    this.searchControl.setValue(item);
  }

  filterLocationItems(value: string): { idEntidad: number; entidad: string }[] {
    const filterValue = value?.toLowerCase();
    return this.locationItems.filter(option => option.entidad.toLowerCase().includes(filterValue));
  }
  selectLocationItem(item: any) {
    this.locationSearchControl.setValue(item);
  }
  showLocationName(objeto: any): string {
    return objeto && objeto.entidad ? objeto.entidad : '';
  }
  filterChanged(event: any) {
    if (event.target.value != "" && event.target.value != "0") {
      this.hasFilters = true;
    }
  }

  cleanSelect(type: string) {
    if (type === "salary")
      this.salaryControl.setValue("-1");
    else if (type === "postDate")
      this.postDateControl.setValue("0");
  }

  cleanFilters() {
    this.hasFilters = false;
    this.searchControl.setValue('');
    this.locationSearchControl.setValue('');
    this.postDateControl.setValue("0");
    this.salaryControl.setValue("-1");
    // Emitir filtros vacíos para mostrar todas las vacantes
    this.emitirFiltros();
    // También navegar si es necesario
    this.searchJobOpenning();
  }
  validateHasFilter() {
    this.hasFilters = (this.postDateControl.value && this.postDateControl.value != "0")
  }

  searchJobOpenning() {
    this.searchControl?.markAllAsTouched();
    if (this.searchControl.invalid) {
      return;
    }

    this.navigateToSearch();
  }

  private navigateToSearch() {
    let filters: any = {};
    
    // Solo agregar filtros con valores válidos
    const searchValue = this.searchControl.value;
    if (searchValue) {
      // Verificar si es string o objeto
      if (typeof searchValue === 'string' && searchValue.trim() !== '') {
        filters.idPuesto = searchValue;
      } else if (typeof searchValue === 'object' && searchValue?.puesto) {
        filters.idPuesto = searchValue.puesto;
      }
    }
    
    const locationValue = this.locationSearchControl.value;
    if (locationValue) {
      // Verificar si es string o objeto
      if (typeof locationValue === 'string' && locationValue.trim() !== '') {
        filters.idUbicacion = locationValue;
      } else if (typeof locationValue === 'object' && locationValue?.entidad) {
        filters.idUbicacion = locationValue.entidad;
      }
    }
    
    if (this.postDateControl.value && this.postDateControl.value != "0") {
      filters.antiguedad = this.postDateControl.value;
    }
    console.log('Navegando con filtros:', this.salaryControl.value);
    if (this.salaryControl.value && this.salaryControl.value != "-1") {
      filters.sueldo = this.salaryControl.value;
    }

    // Solo navegar si hay al menos un filtro de búsqueda válido
    if (Object.keys(filters).length > 0) {
      this.router.navigate(['/buscador'], {
        queryParams: filters
      });
    }
  }
  clearFilters() {
    this.searchControl.setValue('');
    this.locationSearchControl.setValue('');
    this.postDateControl.setValue("0");
    this.salaryControl.setValue("-1");
    this.router.navigate(['/buscador']);
  }

  mostrarFiltros = false;
  toggleFiltros() {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  // Método para emitir filtros basados en el JSON de Appian
  emitirFiltros() {
    const filtros: any = {
      name: '', // Búsqueda por nombre de vacante
      categoria: '', // Filtro por categoría
      ubicacion: '', // Filtro por ubicación
      sueldo_min: null, // Sueldo mínimo
      horario_trabajo: null, // Tipo de horario
      escolaridad: null, // Nivel de estudios
      antiguedad: null // Filtro por fecha de publicación
    };

    // Mapear los controles actuales a los campos de Appian
    if (this.searchControl.value) {
      if (typeof this.searchControl.value === 'string') {
        filtros.name = this.searchControl.value;
      } else if (this.searchControl.value?.puesto) {
        filtros.name = this.searchControl.value.puesto;
      }
    }

    if (this.locationSearchControl.value) {
      if (typeof this.locationSearchControl.value === 'string') {
        filtros.ubicacion = this.locationSearchControl.value;
      } else if (this.locationSearchControl.value?.entidad) {
        filtros.ubicacion = this.locationSearchControl.value.entidad;
      }
    }

    if (this.salaryControl.value && this.salaryControl.value !== '-1') {
      // Extraer el valor numérico del sueldo si es necesario
      const salaryValue = this.salaryItems.find(item => item.idSueldo == this.salaryControl.value);
      if (salaryValue && salaryValue.sueldo) {
        const match = salaryValue.sueldo.match(/(\d+)/);
        if (match) {
          filtros.sueldo_min = parseInt(match[1]);
        }
      }
    }

    if (this.postDateControl.value && this.postDateControl.value !== '0') {
      filtros.antiguedad = this.postDateControl.value;
    }

    // Emitir los filtros
    //this.filtrosChange.emit(filtros);
  }

  // Configurar listeners según el modo (isHome)
  private setupFilterListeners() {
    if (this.isHome) {
      // Modo home: navegar por URL al cambiar filtros con debounce mayor
      this.searchControl.valueChanges.pipe(debounceTime(800)).subscribe(() => {
        this.navigateToSearch();
      });
      this.locationSearchControl.valueChanges.pipe(debounceTime(800)).subscribe(() => {
        this.navigateToSearch();
      });
      this.postDateControl.valueChanges.subscribe(() => {
        this.navigateToSearch();
      });
      this.salaryControl.valueChanges.subscribe(() => {
        this.navigateToSearch();
      });
    } else {
      // Modo buscador: emitir filtros para búsqueda en tiempo real
      this.searchControl.valueChanges.pipe(debounceTime(300)).subscribe(() => this.emitirFiltros());
      this.locationSearchControl.valueChanges.pipe(debounceTime(300)).subscribe(() => this.emitirFiltros());
      this.postDateControl.valueChanges.subscribe(() => this.emitirFiltros());
      this.salaryControl.valueChanges.subscribe(() => this.emitirFiltros());
    }
  }
}
